import React from "react";
import { ICON_SIZE_CLASSES } from "./constants";

// Exam-prep icons are pre-rendered WebP served from the public CDN, one folder
// per app, with the colour baked into each asset. Icons size via a fixed
// tailwind class (TW2 has no arbitrary values); `style` is passed through so
// positioned call sites keep working, and `color` / `strokeWidth` are ignored.
// `onDark` turns an icon white for purple or dark backgrounds.
export const cdnIcon =
  (base) =>
  (name) =>
  ({
    size = 20,
    color: _color,
    strokeWidth: _strokeWidth,
    className = "",
    style,
    onDark = false,
    ...rest
  }) =>
    (
      <img
        src={`${base}/${name}.webp`}
        className={`inline-block flex-shrink-0 object-contain ${
          ICON_SIZE_CLASSES[size] || "h-5 w-5"
        } ${className}${onDark ? " brightness-0 invert filter" : ""}`.trim()}
        style={style}
        alt=""
        aria-hidden={true}
        {...rest}
      />
    );
